import React from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import { HideColumnIcon } from "../../../Tables/Tanstack/assets/svg";

const ColumnHidingDropdown = ({ table }) => {
  return (
    <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        <HideColumnIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div className="toggle_button">
          <Button
            variant="danger toggle"
            {...{
              defaultChecked: table?.getIsSomeColumnsVisible(),
              onClick: table?.getToggleAllColumnsVisibilityHandler(),
            }}
            className="ts__show__button"
          >
            Toggle All
          </Button>
        </div>
        {table?.getAllLeafColumns()?.map((column) => {
          return (
            <div key={column.id} className="ts__column__visible">
              <label className="ts__column_visible_label">
                <div className="switch">
                  <Form.Check
                    {...{
                      type: "switch",
                      checked: column.getIsVisible(),
                      onChange: column.getToggleVisibilityHandler(),
                    }}
                  />
                </div>
                {/* Margin to align checkbox and text */}
                <span style={{ marginTop: "3px" }}>
                  {column.columnDef.header}
                </span>
              </label>
            </div>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ColumnHidingDropdown;
